import { uploadImgPops } from "components/utils/comm";
import { ChangeEvent, useRef } from "react";
import imgUploadApi from "components/api/imgUpload";
import { useTranslation } from "react-i18next";
import useLodStore from "store/lod";
import useAlertStore from "store/alert";
import { upRmFileCd } from "components/constent";

type IProps = {
  data: any;
};

export default function ImageUploadEditor({ data }: IProps) {
  const { t } = useTranslation();
  const lod = useLodStore((state) => state.lod);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);

  const fileInputRef = useRef<HTMLInputElement | null>(null); // 파일 input에 대한 ref

  const onChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.currentTarget.files;
    if (files) {
      let formData = new FormData();
      formData.append("imgTypCd", upRmFileCd);
      formData.append("lodNo", lod?.lodNo ?? "");
      let reader = new FileReader();

      reader.onload = () => {
        if (reader.result) {
          uploadImgPops({
            imgResult: {
              ...data,
              name: files[0].name,
              url: reader.result,
            },
          });
        }
      };
      reader.readAsDataURL(files[0]);
      formData.append("uploadFiles", files[0]);

      if (formData.get("uploadFiles")) {
        const res = await imgUploadApi(formData);
        if (res) {
          const { status, data: resData } = res;
          if (status.code === 0) {
            // const { thumImgPhUrl } = data;
            onSetAlert({
              isOpen: true,
              inner: t("md_txt_img_update_2"),
            });
            const imgList = resData.imgList;

            uploadImgPops({
              modifyInf: {
                ...data,
                imgList: imgList,
              },
            });
          }
        }
      }
    }
  };

  // 파일 선택 창을 열기 위해 모달을 띄우는 함수
  const handleFileClick = () => {
    onSetAlert({
      isOpen: true,
      inner: t("md_txt_img_update_1"),
      cnclBtn: true,
      onSetConfirm: () => {
        if (fileInputRef.current) {
          fileInputRef.current.click(); // 파일 선택 창 열기
        }
      },
    });
  };

  return (
    <div
      className="w-auto min-h-[60px]"
      // style={{ aspectRatio: 1 }}
      onClick={handleFileClick}
    >
      <img src={data.thumImgPhUrl} alt="upload-image" className="p-1" />

      {/* 파일 입력 필드 (실제로는 클릭되지 않도록 숨김 처리) */}
      <input
        hidden
        type="file"
        id="img-modify-modal"
        ref={fileInputRef}
        style={{ display: "none", width: 120, height: 120 }}
        onChange={onChange}
      />
    </div>
  );
}
